export type DeferredSentryUser = { id: string } | null

type DeferredSentryClient = {
  captureException: (error: unknown) => unknown
  setUser: (user: DeferredSentryUser) => unknown
}
type DeferredSentryLoader = () => Promise<void>

const MAX_DEFERRED_ERRORS = 20

let activeClient: DeferredSentryClient | null = null
let loadClient: DeferredSentryLoader | null = null
let loadingPromise: Promise<void> | null = null
let currentUser: DeferredSentryUser = null
const deferredErrors: unknown[] = []

const loadDeferredSentryClient = (): void => {
  if (activeClient || loadingPromise || !loadClient) return

  const pending = Promise.resolve().then(loadClient)
  loadingPromise = pending
  void pending.then(
    () => {
      if (!activeClient && loadingPromise === pending) {
        loadingPromise = null
      }
    },
    () => {
      // Keep queued errors and retry when another error arrives.
      if (loadingPromise === pending) loadingPromise = null
    }
  )
}

export const registerDeferredSentryLoader = (
  loader: DeferredSentryLoader
): void => {
  loadClient = loader
  if (deferredErrors.length > 0) loadDeferredSentryClient()
}

export const captureDeferredSentryException = (error: unknown): void => {
  if (activeClient) {
    activeClient.captureException(error)
    return
  }

  if (deferredErrors.length < MAX_DEFERRED_ERRORS) {
    deferredErrors.push(error)
  }
  loadDeferredSentryClient()
}

export const setDeferredSentryUser = (user: DeferredSentryUser): void => {
  currentUser = user
  activeClient?.setUser(user)
}

export const activateDeferredSentryClient = (
  client: DeferredSentryClient
): void => {
  activeClient = client
  client.setUser(currentUser)
  deferredErrors.splice(0).forEach((error) => client.captureException(error))
}
